












import { Component, Vue, Ref } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
  },
})
export default class SetNewPasswordComponent extends Vue {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  resolve?: (value: string) => void = undefined;
  reject?: (reason: string) => void = undefined;

  colorHex = "";

  async show(title: string, colorHex: string) {
    this.colorHex = colorHex;

    this.baseDialogComponent.show({
      title: title,
      maxWidth: 400,
      positiveButtonText: this.$t("common.submit").toString(),
      negativeButtonText: this.$t("common.abort").toString(),
      closeOnSave: true,
    });

    return new Promise<string>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async onSave() {
    this.baseDialogComponent.isShowing = false;
    this.resolve && this.resolve(this.colorHex);
  }
}
